import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../navbarservice.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  constructor(private navService: NavbarService) { }

  ngOnInit(): void {
    this.navService.hideSet(true)
  }

}
